<template>
  <div>
    <div class="row">
      <div class="col-12 justify-content-center">
        Ingrese su numero de documento:
      </div>
      <div class="col-12 justify-content-center">
        <input class="justify-content-center" type="text" />
      </div>
    </div>    
  </div>
</template>
<script>
export default {
  name: "FormCertificacion",
  components: {},
  methods: {},
  created() {},
  data() {
    return {};
  },
};
</script>

<style></style>
